import { useRef, useState } from 'react'
import type { FormEvent } from 'react'

export function isStandaloneBrowser(): boolean {
  return !window.Telegram?.WebApp?.initData && !['127.0.0.1', 'localhost'].includes(window.location.hostname)
}

export function StandaloneAuth({ onAuthenticated }: { onAuthenticated: () => void }) {
  const [pin, setPin] = useState('')
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)
  const authenticatedRef = useRef(onAuthenticated)
  authenticatedRef.current = onAuthenticated

  async function submit(event: FormEvent) {
    event.preventDefault()
    setError('')
    setBusy(true)
    try {
      const response = await fetch('/api/auth/pin', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ pin }),
      })
      const body = await response.json().catch(() => ({}))
      if (!response.ok) throw new Error(body.error || 'Не удалось войти')
      authenticatedRef.current()
    } catch (authError) {
      setError(authError instanceof Error ? authError.message : 'Не удалось войти')
    } finally {
      setBusy(false)
    }
  }

  return (
    <main className="flex min-h-full items-center justify-center bg-bg-primary p-6 text-center">
      <section className="w-full max-w-md rounded-3xl border border-border-primary bg-bg-secondary p-7 shadow-2xl">
        <div className="mb-3 text-3xl">◈</div>
        <h1 className="text-xl font-bold">O.R.B.I.T.</h1>
        <p className="mt-2 text-sm text-text-secondary">Вход для отдельной иконки на iPhone и iPad</p>
        <p className="mt-4 text-xs leading-5 text-text-muted">Введи личный PIN-код, чтобы открыть планер.</p>
        <form onSubmit={submit} className="mt-6 flex flex-col gap-3">
          <input
            value={pin}
            onChange={event => setPin(event.target.value.replace(/\D/g, '').slice(0, 12))}
            inputMode="numeric"
            autoComplete="current-password"
            type="password"
            placeholder="PIN-код"
            aria-label="PIN-код"
            className="rounded-xl border border-border-primary bg-bg-primary px-4 py-3 text-center text-lg tracking-[0.35em] outline-none"
          />
          <button type="submit" disabled={busy || pin.length < 4} className="rounded-xl bg-accent-primary px-4 py-3 font-semibold disabled:opacity-50">
            {busy ? 'Проверяем…' : 'Войти'}
          </button>
        </form>
        {error && <p className="mt-4 text-xs text-accent-danger">{error}</p>}
      </section>
    </main>
  )
}
